import React, { memo, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useWorkspaceShell } from '../../../contexts/WorkspaceShellContext';

/**
 * Modal placeholder — Command Palette completo en sprint futuro.
 */
const CommandPaletteModal = memo(function CommandPaletteModal() {
  const { commandPaletteOpen, closeCommandPalette } = useWorkspaceShell();

  useEffect(() => {
    if (!commandPaletteOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeCommandPalette();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [commandPaletteOpen, closeCommandPalette]);

  if (!commandPaletteOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm"
        onClick={closeCommandPalette}
        aria-hidden
      />
      <div
        className="fixed left-1/2 top-[15%] z-[101] w-[min(560px,calc(100vw-2rem))] -translate-x-1/2 rounded-xl border border-white/[0.1] bg-e0e3-surface p-4 shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-label="Paleta de comandos"
      >
        <div className="mb-3 flex items-center justify-between">
          <p className="text-sm font-semibold text-white">Command Palette</p>
          <button type="button" onClick={closeCommandPalette} className="rounded-lg p-1 text-e0e3-muted hover:bg-white/[0.08]">
            <FaTimes size={16} />
          </button>
        </div>
        <input
          type="text"
          readOnly
          placeholder="Navegación rápida — disponible próximamente"
          className="nexo-field w-full rounded-lg px-3 py-2.5 text-sm"
        />
        <p className="mt-2 text-xs text-e0e3-muted">
          Arquitectura preparada. CTRL+K abrirá búsqueda de módulos sin cambiar rutas ni permisos.
        </p>
      </div>
    </>
  );
});

export default CommandPaletteModal;
